import React from "react";
import { Container, Row } from "reactstrap";
import LeftSideContent from "./LeftSideContent";
import Section from "./Section";
import { useTranslation } from "react-i18next";
const CompanyDetails = () => {
  const { t } = useTranslation("translation");
  document.title =
    t("Thông tin chi tiết");
  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container fluid>
          <Row>
            <LeftSideContent />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default CompanyDetails;
